import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules'
import './ImageCarousel.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface ImageCarouselProps {
  images: string[];
}

export function ImageCarousel({ images }: ImageCarouselProps) {
  return (
    <div className="my-4 w-full">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={8}
        slidesPerView={3}
        navigation
        pagination={{}}
        loop
        scrollbar={{ draggable: true }}
        style={{
          "--swiper-theme-color": "white",
          "--swiper-pagination-bullet-inactive-color": "white",
          "--swiper-navigation-size": "30px",
          "--swiper-pagination-bullet-inactive-opacity": 0.4,
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image} alt={`Slide ${index + 1}`} style={{ width: '100%' }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
